import { useEffect, useMemo } from 'react'
import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { Colors, Shapes } from 'src/components/theme'
import { Link } from '@mui/material'
import { Flex } from 'src/components/flex-containers'

type TitleValueGridItemProps = {
  title: string
  value: string | string[]
  isValueLink?: boolean
  isEmpty?: boolean
  setIsEmpty?: (isEmpty: boolean) => void
}
const Row = styled(Flex)`
  align-items: start;
  gap: ${Shapes.spacing[2]}px;
`
const Key = styled(Typography)`
  flex: 1;
`
const Item = styled(Typography)`
  flex: 2;
  word-break: break-word;
`
export const TitleValueRow: React.FC<TitleValueGridItemProps> = (props) => {
  const { title, value, isValueLink, isEmpty, setIsEmpty } = props

  const isValidValue = useMemo(() => {
    return Boolean(value && value.length && value !== 'NA' && value !== 'NULL' && value !== 'N/A - N/A')
  }, [value])

  useEffect(() => {
    if (isEmpty && setIsEmpty && isValidValue) {
      setIsEmpty(false)
    }
  }, [isValidValue, isEmpty, setIsEmpty])

  if (!isValidValue) {
    return null
  }

  return (
    <Row>
      <Key variant="textmdm" color={Colors.textDark}>
        {title}
      </Key>
      <Item variant="textmd" color={Colors.textDark}>
        {Array.isArray(value) ? (
          <ArrayValue values={value} areLinks={isValueLink} />
        ) : isValueLink ? (
          <Link href={value} target="_blank">
            Link
          </Link>
        ) : value && value !== 'NA' ? (
          value
        ) : (
          '-'
        )}
      </Item>
    </Row>
  )
}

const ArrayValue: React.FC<{ values: string[]; areLinks?: boolean }> = (props) => {
  const { values, areLinks } = props
  if (!values.length) {
    return <Typography variant="textmd">-</Typography>
  }
  return (
    <>
      {values.map((value, idx) => {
        return areLinks ? (
          <Link key={`${value}-${idx}`} href={value} target="_blank">
            Link
          </Link>
        ) : (
          <Typography variant="textmd">{value && value !== 'NA' ? value : '-'}</Typography>
        )
      })}
    </>
  )
}
